// Vendor
import { createAction, props } from '@ngrx/store';
export const createMetricAlert = createAction('[Alerts App] Create Metric Alert', props());
export const deleteMetricAlert = createAction('[Alerts App] Delete Metric Alert', props());
export const disableMetricAlert = createAction('[Alerts App] Disable Alert', props());
export const enableMetricAlert = createAction('[Alerts App] Enable Alert', props());
export const setAlertNotes = createAction('[Alert Notes Modal] Set Notes for Alert', props());
